import { useDispatch } from 'react-redux';
import { Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { showModalAction } from 'Store/modules/app/actions';
import useTranslation from 'Hooks/useTranslation';
import { useResetUser } from 'Containers/Validations/hooks';
import Modal from 'Components/Modal';
import { WARNING_MODAL } from 'Constants/modals';
import { NewTaxButtonProps } from './types';

const NewTaxButton = ({ flowEnabled }: NewTaxButtonProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const dispatch = useDispatch();
  const { mutate } = useResetUser();

  const handleOnClick = (): void => {
    dispatch(
      showModalAction({
        title: 'UserReset.modal.title',
        content: 'UserReset.modal.description',
        link: null,
        options: {
          type: WARNING_MODAL,
          action: mutate,
          acceptText: 'ReviewTax.modal.acceptText',
          cancelText: 'ReviewTax.modal.cancelText',
          isAcceptDanger: true,
        },
        Component: Modal,
      })
    );
  };

  return (
    <Buttons.Classic
      size="m"
      mode="light"
      disabled={flowEnabled}
      className="submit-button"
      onClick={handleOnClick}
      label={t('TaxScreen.newTax')}
    />
  );
};

export default NewTaxButton;
